<div class="base-container logbook-main-container">
  <div class="panel logbook-filter-panel">
    <!-- Zeitraums-Eingabe (MDC Date Range Input) -->
    <mat-form-field
      appearance="fill"
      class="logbook-range-field"
      (click)="picker.open()"
      subscriptSizing="dynamic">
      <mat-label>{{
        'PRODUCT.SMW.ARCHIVE.SELECT_TIME_RANGE' | translate
      }}</mat-label>
      <mat-date-range-input
        [formGroup]="dateRange"
        [rangePicker]="picker"
        [dateFilter]="dateFilter"
        class="logbook-range-inputs">
        <input
          matStartDate
          formControlName="start"
          placeholder="Startdatum"
          class="logbook-input-element" />
        <input
          matEndDate
          formControlName="end"
          placeholder="Enddatum"
          class="logbook-input-element" />
      </mat-date-range-input>

      <mat-datepicker-toggle matSuffix [for]="picker">
        <fa-icon
          matDatepickerToggleIcon
          [icon]="['far', 'calendar-alt']"
          transform="up-1 shrink-2"
          size="lg"></fa-icon>
      </mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <!-- Validierungsfehler -->
    <div class="logbook-validation-errors">
      @if (startHasMatError()) {
        <mat-error>Invalid start date</mat-error>
      } @else if (endHasMatError()) {
        <mat-error>Invalid end date</mat-error>
      }
      @if (startHasMatRequiredError()) {
        <mat-error>Start date is required</mat-error>
      } @else if (endHasMatRequiredError()) {
        <mat-error>End date is required</mat-error>
      }
    </div>

    <!-- Abfrage-Button -->
    <button
      mat-flat-button
      color="primary"
      class="btn-logbook-query"
      (click)="onQueryData()"
      [disabled]="dateRangeInvalid()">
      <fa-icon [icon]="['far', 'th']"></fa-icon> &nbsp;
      {{ 'PRODUCT.SMW.ARCHIVE.QUERY_DATA' | translate }}
    </button>
  </div>

  <!-- 2. LOGBUCH DATEN-TABELLE (Eingebettet in Milchglas-Card) -->
  @let logbookDataValue = logbookData();
  @if (logbookDataValue) {
    <mat-card
      appearance="outlined"
      class="table-card smw-table-container logbook-data-card">
      <div class="logbook-table-scroll-wrapper">
        <table class="logbook-native-table">
          <thead>
            <tr class="logbook-header-row">
              <th class="col-dtg">{{ 'PRODUCT.LOGBOOK.DTG' | translate }}</th>
              <th class="col-contact">
                {{ 'PRODUCT.LOGBOOK.CONTACT' | translate }}
              </th>
              <th class="col-author">
                {{ 'PRODUCT.LOGBOOK.AUTHOR' | translate }}
              </th>
              <th class="col-subject">
                {{ 'PRODUCT.LOGBOOK.SUBJECT' | translate }}
              </th>
              <th class="col-text">{{ 'PRODUCT.LOGBOOK.TEXT' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (entry of logbookDataValue; track $index) {
              <tr class="logbook-body-row">
                <!-- Spalte 1: Datum & Uhrzeit -->
                <td class="cell-dtg">
                  <div class="logbook-date-string">
                    <span class="date-main">
                      {{
                        entry.createDtg
                          | datex
                            : 'DD.MM.YYYY'
                            : undefined
                            : languageService.langSignal()
                      }}
                    </span>
                    <span class="time-sub">
                      {{
                        entry.createDtg
                          | datex
                            : 'HH:mm'
                            : undefined
                            : languageService.langSignal()
                      }}
                    </span>
                  </div>
                </td>

                <!-- Spalte 2: Kontakt -->
                <td class="cell-contact">
                  <span class="logbook-badge-info">{{ entry.contact }}</span>
                </td>

                <!-- Spalte 3: Autor / Verfasser -->
                <td class="cell-author">
                  <strong>{{ entry.author }}</strong>
                </td>

                <!-- Spalte 4: Betreff -->
                <td class="cell-subject">
                  <span class="subject-text-highlight">{{
                    entry.subject
                  }}</span>
                </td>

                <!-- Spalte 5: Nachrichtentext (Aufgeteilt nach Zeilenumbrüchen) -->
                <td class="cell-text">
                  <div class="logbook-message-paragraph-box">
                    @for (line of entry.message.split('\n'); track $index) {
                      <p class="logbook-message-line">
                        {{ line }}
                      </p>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-card>
  }
</div>
